import Keycloak from 'keycloak-js';

const authClient = new Keycloak({
  url: window._env_.KEYCLOAK_HOST,
  realm: window._env_.KEYCLOAK_REALM,
  clientId: window._env_.KEYCLOAK_CLIENT_ID
});

export default authClient;
